import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import {InlineSvgPlugin} from 'vue-inline-svg'
import DatePicker from 'vue2-datepicker'
import HeaderPage from '@/components/HeaderPage'
import Table from '@/components/UI/Table/Table'
import TableColumn from '@/components/UI/Table/TableColumn'
import TableRow from '@/components/UI/Table/TableRow'
import Modal from '@/components/UI/Modal'
import Loader from '@/components/UI/Loader'
import BookBackground from '@/components/UI/BookBackground'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import vSelect from 'vue-select'
import dayjs from 'dayjs'
import vClickOutside from 'v-click-outside'
import Toasted from 'vue-toasted'
import VTooltip from 'v-tooltip'
import Pagination from 'vue-pagination-2'
import VueClipboard from 'vue-clipboard2'
import VueStickyElement from 'vue-sticky-element'
import VueMeta from 'vue-meta'
import { VueMaskDirective } from 'v-mask'
import ru from 'vue2-datepicker/locale/ru'
import en from 'vue2-datepicker/locale/en'
import tr from 'vue2-datepicker/locale/tr'
import es from 'vue2-datepicker/locale/es'
import id from 'vue2-datepicker/locale/id'
import isoWeek from 'dayjs/plugin/isoWeek'
import weekday from 'dayjs/plugin/weekday'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import i18n from './helpers/i18n'
import VueYandexMetrika from 'vue-yandex-metrika'

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vue-select/dist/vue-select.css'
import 'material-icons/iconfont/material-icons.scss'
import 'v-tooltip/dist/v-tooltip.css'
import '@/assets/css/global.scss'
import 'vue2-datepicker/index.css'

en.formatLocale.firstDayOfWeek = 1
ru.formatLocale.firstDayOfWeek = 1
tr.formatLocale.firstDayOfWeek = 1
es.formatLocale.firstDayOfWeek = 1
id.formatLocale.firstDayOfWeek = 1

Vue.use(vClickOutside)
Vue.use(PerfectScrollbar)
Vue.use(InlineSvgPlugin)
Vue.use(VueClipboard)
Vue.use(VTooltip, {
  offset: [0, 10]
})
Vue.use(Toasted)
Vue.use(VueStickyElement)
Vue.use(VueMeta)

if (document.location.origin.indexOf('.dev.') === -1) {
  Vue.use(VueYandexMetrika, {
    id: 90660984,
    router: router,
    env: process.env.NODE_ENV,
    options: {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    }
  })
}


Vue.toasted.register('all_ok',
  (payload) => {
    return payload
  },
  {
    className: 'toasted--success',
    icon: 'check_circle',
    duration: '3000',
    position: 'bottom-right'
  }
)

Vue.directive('mask', VueMaskDirective);
Vue.toasted.register('all_mistake',
  (payload) => {
    return payload
  },
  {
    className: 'toasted--danger',
    icon: 'error',
    duration: '2000',
    position: 'bottom-right'
  }
)

axios.interceptors.response.use(
  response => response,
  error => {
    console.log('Перехватили ошибку:', error.response.status); // Добавьте логирование статуса ошибки
    if (error.response && error.response.status === 403) {
      console.log('Перенаправление на 403');
      router.push({ name: 'NotFound', query: { code: 403 }});
    }
    return Promise.reject(error);
  }
);


Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$dayjs.extend(weekday)
Vue.prototype.$dayjs.extend(isoWeek)
Vue.prototype.$dayjs.extend(utc)
Vue.prototype.$dayjs.extend(timezone)
Vue.prototype.$dayjs.extend(customParseFormat)
Vue.prototype.$dayjs.tz.setDefault("Europe/Moscow")

Vue.component('pagination', Pagination)
Vue.component("v-select", vSelect);
Vue.component('datepicker', DatePicker)
Vue.component('header-page', HeaderPage)
Vue.component('base-table', Table)
Vue.component('base-table-column', TableColumn)
Vue.component('base-table-row', TableRow)
Vue.component('loader', Loader)
Vue.component('modal', Modal)
Vue.component('BookBackground', BookBackground)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
